import React, { useContext, useEffect, useState } from "react";
import { StatusType } from "../../../services/firebase/auth-context/reducer";
import { accessByMail, articleVisibilityIsOpen, articleVisibilityIsPlus, hasAccessToArticle, hasActivePlusSubscription, hasActiveSubscription, isEditorialOrBriefing } from "../../../util/subscription/access";
import AuthContext from "../../../services/firebase/auth-context/provider";
import ContentText from "./content-text";
import IPBasedLoginContext from "../../../services/ip-based-login/provider";
import ContentRelatedArticles from "./content-related-articles";
import ContentImage from "./content-image";
import ImageModal from "../../common/image-modal";
import VgWortPixel from "../vg-wort-pixel";
import { loadArticleData } from "../../../services/firebase/util";
import SubscriptionRequestEdition from "../subscription-request/edition";
import SubscriptionRequestSpotlight from "../subscription-request/spotlight";
import SiteOverlay from "../../site-overlay";
import { Link } from "gatsby";
var ArticleContent = function ArticleContent(_ref) {
    var article = _ref.article, withSpotlight = _ref.withSpotlight;
    var _useContext$ = useContext(AuthContext)[0], authenticated = _useContext$.authenticated, user = _useContext$.user, userClaims = _useContext$.userClaims;
    var ipBased = useContext(IPBasedLoginContext);
    var _useState = useState(false), showFree = _useState[0], setShowFree = _useState[1];
    var _useState2 = useState(null), selectedImage = _useState2[0], selectImage = _useState2[1];
    var _useState3 = useState(false), modalStatus = _useState3[0], setModalStatus = _useState3[1];
    var _useState4 = useState(null), pixel = _useState4[0], setPixel = _useState4[1];
    var _useState5 = useState(false), spotlightCircle = _useState5[0], setSpotlightCircle = _useState5[1];
    var _hasAccessToArticle = hasAccessToArticle(userClaims, authenticated, article.visibility, article.id, user === null || user === void 0 ? void 0 : user.email);
    var _hasActiveSubscription = hasActiveSubscription(userClaims) || accessByMail(user === null || user === void 0 ? void 0 : user.email);
    var _hasActivePlusSubscription = hasActivePlusSubscription(userClaims);
    var _isEditorialOrBriefing = isEditorialOrBriefing(article.articleType);
    var customerId = (userClaims === null || userClaims === void 0 ? void 0 : userClaims.status) === StatusType.SUCCESS ? userClaims.data.customerId : "";
    var showFreeArticle = function showFreeArticle() {
        return setShowFree(true);
    };
    var showModal = function showModal() {
        return setModalStatus(true);
    };
    var closeModal = function closeModal() {
        return setModalStatus(false);
    };
    var closeSpotlightCircle = function closeSpotlightCircle() {
        return setSpotlightCircle(false);
    };
    useEffect(function () {
        if (!_hasActiveSubscription && !ipBased) {
            setSpotlightCircle(true);
        }
        else {
            setSpotlightCircle(false);
        }
    }, [userClaims, user]);
    useEffect(function () {
        loadArticleData(article.id).then(function (data) {
            setPixel(data.pixel);
        });
    }, []);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, (!_hasAccessToArticle || !_hasActiveSubscription) && !_isEditorialOrBriefing && !showFree && !ipBased && !articleVisibilityIsOpen(article.id, article.visibility) ? buildSubscriptionRequestWithSample(article, withSpotlight, showFreeArticle, authenticated, _hasActivePlusSubscription, customerId) : buildFullContent(article, selectImage, showModal), /*#__PURE__*/ React.createElement(ImageModal, {
        modalStatus: modalStatus,
        closeModal: closeModal,
        image: selectedImage
    }), pixel && /*#__PURE__*/ React.createElement(VgWortPixel, {
        pixel: pixel
    }), withSpotlight && false && /*#__PURE__*/ React.createElement(SiteOverlay, {
        onClose: closeSpotlightCircle,
        open: spotlightCircle
    }, /*#__PURE__*/ React.createElement(Link, {
        to: "/abonnieren/",
        className: "block font-bold text-white mx-auto rounded-full bg-makroGreen shadow",
        style: {
            width: "400px",
            height: "400px",
            padding: "70px 85px",
            fontSize: "1.75rem"
        }
    }, /*#__PURE__*/ React.createElement("p", {
        className: "mb-2"
    }, "Das Spotlight ist exklusiv f\xFCr Abonnenten."), /*#__PURE__*/ React.createElement("p", null, "Jetzt abonnieren!"))));
};
export default ArticleContent;
var buildFullContent = function buildFullContent(article, selectImage, showModal) {
    return article && article.content && article.content.length > 0 ? article.content.map(function (item, index) {
        return renderContentItem(item, index, selectImage, showModal);
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null);
};
var renderContentItem = function renderContentItem(item, index, selectImage, showModal) {
    var out = /*#__PURE__*/ React.createElement(React.Fragment, null);
    switch (item["__typename"]) {
        case "DatoCmsText":
            out = /*#__PURE__*/ React.createElement(ContentText, {
                index: index,
                key: index,
                text: item.text
            });
            break;
        case "DatoCmsImage":
            out = /*#__PURE__*/ React.createElement(ContentImage, {
                index: index,
                key: index,
                image: item,
                selectImage: selectImage,
                showModal: showModal
            });
            break;
        case "DatoCmsRelatedArticlesBox":
            out = /*#__PURE__*/ React.createElement(ContentRelatedArticles, {
                index: index,
                key: index,
                articles: item.articles
            });
            break;
    }
    return out;
};
var buildSubscriptionRequestWithSample = function buildSubscriptionRequestWithSample(article, isSpotlight, showFreeArticle, authenticated, hasActivePlusSubscription, customerId) {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ContentText, {
        index: 0,
        text: buildSample(article)
    }), isSpotlight ? buildSubscriptionRequestSpotlightWithSample(article, showFreeArticle, authenticated, hasActivePlusSubscription, customerId) : buildSubscriptionRequestEditionWithSample(article, showFreeArticle));
};
var buildSubscriptionRequestEditionWithSample = function buildSubscriptionRequestEditionWithSample(article, showFreeArticle) {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, articleVisibilityIsOpen(article.id, article.visibility) ? /*#__PURE__*/ React.createElement(SubscriptionRequestEdition, {
        type: "free",
        loadFullArticle: showFreeArticle
    }) : /*#__PURE__*/ React.createElement(SubscriptionRequestEdition, {
        type: "paywall",
        loadFullArticle: showFreeArticle
    }));
};
var buildSubscriptionRequestSpotlightWithSample = function buildSubscriptionRequestSpotlightWithSample(article, showFreeArticle, authenticated, hasActivePlusSubscription, customerId) {
    if (articleVisibilityIsOpen(article.id, article.visibility)) {
        return /*#__PURE__*/ React.createElement(SubscriptionRequestSpotlight, {
            loadFullArticle: showFreeArticle,
            type: "free"
        });
    }
    else if (articleVisibilityIsPlus(article.visibility)) {
        return /*#__PURE__*/ React.createElement(SubscriptionRequestSpotlight, {
            loadFullArticle: showFreeArticle,
            type: "plus",
            customerId: customerId,
            nonPlusSubscriber: authenticated && !hasActivePlusSubscription
        });
    }
    else {
        return /*#__PURE__*/ React.createElement(SubscriptionRequestSpotlight, {
            loadFullArticle: showFreeArticle,
            type: "paywall"
        });
    }
};
var buildSample = function buildSample(article) {
    var sample = "";
    if (article.content && article.content.length > 0 && article.content[0]["__typename"] == "DatoCmsText") {
        var text = article.content[0];
        var textInner = text.text;
        var regexTeaser = /(.*?<\/h3>)?/;
        var teaser = textInner.match(regexTeaser);
        sample = teaser && teaser.length > 0 ? teaser[0] : "";
        textInner = textInner.replace(regexTeaser, "");
        var s = (textInner.split("</p>").splice(0, 2).join("</p>") + "</p>").replace(/<\/p> *<\/p>/g, "</p>");
        sample += s + " [...]";
    }
    return sample;
};
